import filter from 'lodash/filter';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import sumBy from 'lodash/sumBy';
import uniqWith from 'lodash/uniqWith';
import { stringToBoolean } from '../utilities/conversionUtility';
import { defaultAvailabilityMessage, formatAvailabilityMessage } from '../utilities/helperUtility';
import { getVariantsFilteredBySeason } from './ActivityPage/helpers';

import Translation from '../utilities/localizationUtility';
import { formatHours } from '../utilities/timeUtility';
import dayjs from '../../dayjs/dayjs_timezone';

export const getTimeslot = (frame, date, allowFirstSlot = false) => {
  const timeslots = frame ? frame.timeslots : null;
  let timeslot = null;

  if (timeslots) {
    timeslot = timeslots.find((x) => dayjs(x.start).isSame(date));

    if (!timeslot && allowFirstSlot) {
      return timeslots[0];
    }
  }

  return timeslot;
};

export const getAvailableSlot = (slot, capacityType, maxAvailability, variantIds) => {
  if (
    slot.availability.some((x) => x.status === 4)
    || (capacityType === 0 && slot.availability.every((x) => x.status === 2))
  ) {
    return 0;
  }

  let { availability } = slot;

  if (capacityType === 2) { return slot.resource_availability }

  return maxAvailability - sumBy(availability, 'bookings');
};

export const parseAvailableDates = (props) => {
  const { frames, selectedLocation, timeZone } = props;
  const locationId = selectedLocation?.id;
  const today = dayjs().tz(timeZone);

  return frames.reduce((arr, frame) => {
    const theDate = dayjs.tz(frame.date, timeZone);
    const isValid = theDate.isSameOrAfter(today.clone().startOf('day'))
      && (!locationId || frame.timeslots.some((x) => !x.location_id || x.location_id === locationId));

    if (isValid && find(frame.timeslots, (x) => dayjs(x.start).tz(timeZone).isSameOrAfter(today))) {
      arr.push(frame.date);
    }

    return arr;
  }, []);
};

export const parseSelectOptions = (selectedDate, props) => {
  const {
    allDay,
    capacityType,
    frames,
    locale,
    maxAvailability,
    selectedLocation,
    setting,
    timeZone,
    totalQuantity,
  } = props;
  const isDisplayRange = stringToBoolean(setting.display_time_range);
  const showRemainingPlaces = stringToBoolean(setting.show_remaining_places);
  const locationId = selectedLocation ? selectedLocation.id : null;
  const translation = new Translation(props);
  const timeFormat = setting.time_format;

  if (selectedDate) {
    const now = dayjs();
    const currentFrame = find(frames, (x) => x.date === selectedDate);

    if (currentFrame) {
      const timeslots = filter(currentFrame.timeslots, (x) => (
        dayjs(x.start).isSameOrAfter(now)
          && (!locationId || !x.location_id || x.location_id === locationId)
      )).sort((x, y) => (
        dayjs(y.start).isSameOrAfter(dayjs(x.start)) ? -1 : 1
      ));

      const optionsArray = timeslots.map((x) => {
        const variantIds = getVariantsFilteredBySeason({...props, ...{ selectedTimeslot: x.start } }).map(v => v.id);
        const availability = getAvailableSlot(x, capacityType, maxAvailability, variantIds);
        const details = availability <= 0 ? x.availability.find((a) => a.status !== 1)?.status_detail : null;
        const message = showRemainingPlaces
          ? formatAvailabilityMessage(availability, totalQuantity, translation)
          : defaultAvailabilityMessage(availability, translation);
        let label = formatHours(x.start, locale, timeZone, timeFormat).toUpperCase();

        if (isDisplayRange && !allDay) {
          label += ` - ${formatHours(x.finish, locale, timeZone, timeFormat).toUpperCase()}`;
        }

        if (showRemainingPlaces) {
          label += ` / ${message}`;
        }

        return {
          label: !allDay ? label : `${message}`,
          details,
          value: x.start,
        };
      });

      return uniqWith(optionsArray, isEqual);
    }
  }

  return [];
};
